import { cn } from '@/lib/utils'

export const LoadingGraphics = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="109" height="108" viewBox="0 0 109 108" fill="none">
      <rect x="0.5" width="108" height="108" fill="white" fillOpacity="0.01" />
      <rect
        x="34.3554"
        y="8.20923"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(10 34.3554 8.20923)"
        fill="url(#paint0_linear_1124_16799)"
      />
      <rect
        x="27.6324"
        y="7.5"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(5 27.6324 7.5)"
        fill="url(#paint1_linear_1124_16799)"
      />
      <rect
        x="20.4542"
        y="7.58911"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        fill="white"
        stroke="#E2E8F0"
        strokeWidth="1.16985"
        strokeLinecap="square"
      />
      <g className={cn('origin-[54.5px_49px] animate-spin')}>
        <circle cx="54.5" cy="49" r="15.5" stroke="#CBD5E1" strokeWidth="5" />
        <path
          d="M55 64.5C46.1634 64.5 39 57.5604 39 49C39 40.4396 46.1634 33.5 55 33.5"
          stroke="#2563EB"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1124_16799"
          x1="34.3554"
          y1="8.20923"
          x2="34.3554"
          y2="90.8787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0045D7" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1124_16799"
          x1="-6.81322"
          y1="48.8347"
          x2="74.501"
          y2="116.597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98B9FF" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
